import React, { useEffect, useState } from "react"
import { createPortal } from "react-dom"

import PageWrapper from "Pages/@PageWrapper"
import { REPORT_ROUTES } from '@constants'
import { AlertsSubtitle } from "Pages/ReportsAlerts/Alerts/@components"
import { Box, Grid } from "@mui/material"
import { AlertsTabs } from "Pages/ReportsAlerts/Alerts/@components"
import CreateAlertsButton from "Pages/ReportsAlerts/Alerts/Conditions/CreateAlerts"
import { alertsSection } from "Pages/ReportsAlerts/Alerts/@signals"
import { ALERTS } from "Pages/ReportsAlerts/Alerts/@constants"
import NoAvailabilityBlock from "Pages/ReportsAlerts/Alerts/Conditions/NoAvailability"
import PriceChangeBlock from "Pages/ReportsAlerts/Alerts/Conditions/PriceChange"
import PriceComparisonBlock from "Pages/ReportsAlerts/Alerts/Conditions/PriceComparison"
import RatingBlock from "Pages/ReportsAlerts/Alerts/Conditions/Rating"
import MinMaxPriceBlock from "Pages/ReportsAlerts/Alerts/Conditions/MinMax"
import VirtualTourButton, { TourOverlay, TOUR_STEPS } from "./VirtualTour"
import ConditionsDemoData from "./VirtualTour/DemoData"
import { isTourDemoActive } from "@signals/app"


export default function ConditionsPage() {
	const [tourActive, setTourActive] = useState(false)

	useEffect(() => {
		return () => {
			alertsSection.value = ALERTS.PRICE_COMPARISON
		}
	}, [])

	return <PageWrapper
		head={"DS Rentacar | Alerts"}
		title={REPORT_ROUTES.CONDITIONS_TITLE}
		subtitle={<AlertsSubtitle/>}
		actions={<VirtualTourButton onClick={() => { setTourActive(true); isTourDemoActive.value = true }} />}
	>
		<Grid container>
			<Grid item xs={12}>
				<AlertsTabs/>
			</Grid>
			<Grid item xs={12} sx={{ mt: 10, display: "flex", justifyContent: "end" }}>
				<CreateAlertsButton/>
			</Grid>
		</Grid>
		<MinMaxPriceBlock />
		<NoAvailabilityBlock />
		<PriceChangeBlock />
		<PriceComparisonBlock />
		<RatingBlock />
		{tourActive && !document.querySelector('.MuiTable-root tbody tr') && <ConditionsDemoData/>}
		{tourActive && createPortal(
			<TourOverlay steps={TOUR_STEPS} onClose={() => { setTourActive(false); isTourDemoActive.value = false }} />,
			document.body
		)}
	</PageWrapper>
}